import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

const skeletonVariants = tv({
  base: "inline-block animate-pulse rounded bg-surface-muted motion-reduce:animate-none",
});

export const Skeleton = ({ className, ...props }: ComponentProps<"span">) => {
  return <span aria-hidden="true" className={skeletonVariants({ className })} {...props} />;
};
